import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'

let filtersCopy = JSON.parse(JSON.stringify(filters))

export const tagModelNames = {
    'chat': 'چت',
    'user': 'کاربران',
}


export default {
    namespaced: true,
    state: {
        ...filtersCopy,
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        createTag({commit}, form) {

            let req = axios.post(`/tag`, form)
            return req
        },
        updateTag({commit}, form) {
            let req = axios.put(`/tag/${form.id}`, form)
            return req
        },
        getTags({commit, state}, form) {
            const query = queryBuilder(state.filters)
            let req = axios.get(`/tag?page=${form.page}&${query}`)
            return req
        },
        showSingleTag({commit}, form) {
            let req = axios.get(`/tag/${form.id}`)
            return req
        },
        deleteTag({commit}, form) {
            let req = axios.delete(`/tag/${form.id}`)
            return req
        },
        getTagsTrash({commit}, form) {
            let req = axios.get(`/tags/trash?page=${form.id}`)
            return req
        },
        restoreTag({commit}, form) {
            let req = axios.post(`tags/${form.id}/restore`)
            return req
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}